<template>
    <ContainerWithMenu>
        <div class="page-content">
            <h1 class="h2 margin-0">Riepilogo Cassa</h1>
        </div>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";

    export default {
        name: "CashReport",
        components: { ContainerWithMenu }
    };
</script>
